import React, { FC } from 'react';
import styled from '@emotion/styled';
import CheckIcon from '~Assets/icons/check.svg';

const Image = styled.div<{ icon: any; compact?: boolean }>`
  width: ${({ compact }) => (compact ? 12 : 16)}px;
  height: ${({ compact }) => (compact ? 12 : 16)}px;
  mask-image: url(${({ icon }) => icon});
  mask-size: contain;
  mask-repeat: no-repeat;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: var(--colorWhite);
`;

/** Use with useButton. `compact` gives tighter padding, e.g. on handy */
export const OptionButton = styled.div<{
  selected: boolean;
  disabled?: boolean;
  compact?: boolean;
}>`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  display: flex;
  text-transform: none;
  font-weight: 400;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ compact }) => (compact ? 12 : 16)}px;
  padding: ${({ compact }) => (compact ? '12px 12px' : '18px 16px')};
  color: var(--colorWhite);
  transition: all 0.2s ease-out;
  background-color: ${({ selected }) =>
    selected ? 'var(--colorBlueGray1100)' : 'var(--colorBlueGray1200)'};
  &:active {
    background-color: var(--colorBlueGray1100);
  }
`;

const Circle = styled.div<{ active: boolean; compact?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ active }) => (active ? 'var(--colorBlueGray800)' : 'var(--colorBlueGray1200)')};
  height: ${({ compact }) => (compact ? 18 : 24)}px;
  width: ${({ compact }) => (compact ? 18 : 24)}px;
  flex-shrink: 0;
  border-radius: 50%;
  border: ${(props) =>
    props.active ? '1px solid var(--colorBlueGray700)' : '1px solid var(--colorBlueGray1000)'};
`;

interface Props {
  active: boolean;
  /** Smaller circle, e.g. on handy */
  compact?: boolean;
}

/** Radio options */
const RadioIcon: FC<Props> = ({ active, compact = false }) => {
  return (
    <Circle active={active} compact={compact}>
      {active && <Image icon={CheckIcon} compact={compact} />}
    </Circle>
  );
};

export default RadioIcon;
